import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';

@Component({
  selector: 'app-ads-slider',
  templateUrl: './ads-slider.component.html',
  styleUrls: ['./ads-slider.component.css']
})
export class AdsSliderComponent implements OnInit {

  AdsSliderList: any;
  Submitted: boolean = false;
  SelectedFileForUpload:any;
 
  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SliderModel = {
    TargetUrl: '',
    AdsID: 0,
    IsActive: true,
  };

  Clear() {

    this.SliderModel.AdsID = 0;
    this.SliderModel.TargetUrl = '';   
  };


  GetAdsSlider() {
    this.spinnerService.show();
    this.superadminservice.GetAdsSlider().subscribe((response: any) => {
      this.AdsSliderList = response.AdsSliderList;
      this.spinnerService.hide();
      // this.globalHelper.CheckActionStatus(response);
    });
  };

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
};



SaveAdsSlider() {  
 
      this.spinnerService.show();
      this.superadminservice.SaveAdsSlider(JSON.stringify(this.SliderModel),this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status && this.SliderModel.AdsID == 0) {
          this.Clear();
        }
        this.GetAdsSlider();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    
  }

  EditSlider(obj) {  
    this.SliderModel.AdsID = obj.AdsID;
    this.SliderModel.TargetUrl = obj.TargetUrl; 
  };


  AdsSliderMarkActive(obj) {
    this.Clear();
    this.SliderModel.AdsID = obj.AdsID;
    this.SliderModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.superadminservice.AdsSliderMarkActive(JSON.stringify(this.SliderModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAdsSlider();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {    
    this.GetAdsSlider();
  }

}






